import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuComponent } from "../../components/menu/menu.component";
import { ApiService, CommonFunctionsService, DatastoreService } from '../../services';
import { NgxSpinnerService } from "ngx-spinner";
import moment from 'moment-timezone';
import { FormBuilder, FormGroup, FormArray, Validators, Form, FormControl } from '@angular/forms';

@Component({
  selector: 'app-give-notice',
  templateUrl: './give-notice.component.html',
  styleUrls: ['./give-notice.component.scss']
})
export class GiveNoticeComponent implements OnInit {

  config: any;
  site: string = "";
  companyDetails: any;
  company: any;
  service: any;
  booking: any;
  dates: {
    betweenStart: string,
    betweenEnd: string,
    before: string,
    after: string
  } = {
    betweenStart: '',
    betweenEnd: '',
    before: '',
    after: ''
  };
  guidanceMessage: string = '';
  giveNoticeGuidanceMessage: string = '';
  bookNoticeGuidanceMessage: string = '';
  hasRules: boolean = false;
  notice1Date: string = '';
  notice2Date: string = '';
  giveNotice1Form: FormGroup;
  giveNotice2Form: FormGroup;
  giveNotice1FormEditing: boolean = false;
  giveNotice2FormEditing: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private dataStore: DatastoreService,
    private commonFunctionsService: CommonFunctionsService,
    private apiService: ApiService,
    private spinner: NgxSpinnerService,
    private router: Router
  ) { }

  get form1() { return this.giveNotice1Form.controls; }
  get form2() { return this.giveNotice2Form.controls; }

  ngOnInit(): void {
    this.giveNotice1Form = new FormGroup({});
    this.giveNotice2Form = new FormGroup({});
    this.route.params.subscribe(async params => {
      await this.commonFunctionsService.setCompanyName(params);
      this.site = params.site;
    });

    this.company = this.dataStore.selectedCompany;
    if (!this.company) {
      const companyStr = localStorage.getItem('company') as string;
      this.company = JSON.parse(companyStr);
    }
    this.dataStore.company = this.company;
    console.log(this.dataStore);

    this.service = this.dataStore.selectedService;
    if (!this.service) {
      const serviceStr = localStorage.getItem('service') as string;
      this.service = JSON.parse(serviceStr);
    }

    this.booking = this.dataStore.booking;
    if (!this.booking) {
      const bookingStr = localStorage.getItem('ceremony') as string;
      this.booking = JSON.parse(bookingStr);
    }
    console.log(this.booking);

    this.setup();
  }

  async setup() {
    const ceremonyDate = moment(this.booking.datetime).utc().tz('Europe/London');
    console.log(this.booking.datetime, ceremonyDate.format('YYYY-MM-DD'));

    const configStr = this.dataStore.config;
    const config = JSON.parse(configStr);
    console.log(config);
    this.config = config;
    if (config.hasOwnProperty('myCeremony')) {
      if (config.myCeremony.hasOwnProperty('give-notice')) {
        if (config.myCeremony['give-notice'].hasOwnProperty('rules')) {
          this.hasRules = true;
          if (config.myCeremony['give-notice'].rules.hasOwnProperty('between')) {
            const scale = config.myCeremony['give-notice'].rules.between.scale;
            if (config.myCeremony['give-notice'].rules.between.hasOwnProperty('start')) {
              const cleanModifier = parseInt(`${config.myCeremony['give-notice'].rules.between.start}`.substring(1));
              console.log(cleanModifier, scale);
              if (config.myCeremony['give-notice'].rules.between.start < 0) {
                this.dates.betweenStart = moment(ceremonyDate).subtract(cleanModifier, scale).format('DD/MM/YYYY');
              }
              else {
                this.dates.betweenStart = moment(ceremonyDate).add(cleanModifier, scale).format('DD/MM/YYYY');
              }
            }
            if (config.myCeremony['give-notice'].rules.between.hasOwnProperty('end')) {
              const cleanModifier = parseInt(`${config.myCeremony['give-notice'].rules.between.end}`.substring(1));
              if (config.myCeremony['give-notice'].rules.between.end < 0) {
                this.dates.betweenEnd = moment(ceremonyDate).subtract(cleanModifier, scale).format('DD/MM/YYYY');
              }
              else {
                this.dates.betweenEnd = moment(ceremonyDate).add(cleanModifier, scale).format('DD/MM/YYYY');
              }
            }
          }

          if (config.myCeremony['give-notice'].rules.hasOwnProperty('before')) {
            const scale = config.myCeremony['give-notice'].rules.before.scale;
            if (config.myCeremony['give-notice'].rules.before.hasOwnProperty('start')) {
              const cleanModifier = parseInt(`${config.myCeremony['give-notice'].rules.before.start}`.substring(1));
              console.log(cleanModifier, scale);
              if (config.myCeremony['give-notice'].rules.before.start < 0) {
                this.dates.before = moment(ceremonyDate).subtract(cleanModifier, scale).format('DD/MM/YYYY');
              }
              else {
                this.dates.before = moment(ceremonyDate).add(cleanModifier, scale).format('DD/MM/YYYY');
              }
            }
          }

          if (config.myCeremony['give-notice'].rules.hasOwnProperty('after')) {
            for (const rule of config.myCeremony['give-notice'].rules.after) {
              const scale = rule.scale;
              const trigger = rule.trigger;
              if (rule.hasOwnProperty('start')) {
                const cleanModifier = parseInt(`${rule.start}`.substring(1));
                console.log(cleanModifier);
                  console.log(cleanModifier, scale, trigger);
                  if (trigger.length > 0) {
                    let applyRule = false;
                    for (const t of trigger) {
                      const answer = this.getBookingOutcomeAnswer(t.question);
                      console.log(answer);
                      if (answer && answer.toLowerCase() === t.value.toLowerCase()) {
                        applyRule = true;
                      }
                    }
                    console.log('applyRule', applyRule);
                    if (applyRule) {
                      // only apply this rule if the trigger matches
                      if (rule.start < 0) {
                        this.dates.after = moment(ceremonyDate).subtract(cleanModifier, scale).format('DD/MM/YYYY');
                      }
                      else {
                        this.dates.after = moment(ceremonyDate).add(cleanModifier, scale).format('DD/MM/YYYY');
                      }
                    }
                  }
                  else {
                    // default behaviour
                    if (rule.start < 0) {
                      this.dates.after = moment(ceremonyDate).subtract(cleanModifier, scale).format('DD/MM/YYYY');
                    }
                    else {
                      this.dates.after = moment(ceremonyDate).add(cleanModifier, scale).format('DD/MM/YYYY');
                    }
                  }
              }
            }
          }

        }
        if (config.myCeremony['give-notice'].hasOwnProperty('guidance')) {
          this.guidanceMessage = config.myCeremony['give-notice'].guidance;
        }
        if (config.myCeremony['give-notice'].hasOwnProperty('give_notice_status_guidance')) {
          this.giveNoticeGuidanceMessage = config.myCeremony['give-notice'].give_notice_status_guidance;
        }
        if (config.myCeremony['give-notice'].hasOwnProperty('book_notice_guidance')) {
          this.bookNoticeGuidanceMessage = config.myCeremony['give-notice'].book_notice_guidance;
        }
        
        if (config.myCeremony['give-notice'].hasOwnProperty('outcomes')) {
          if (config.myCeremony['give-notice'].outcomes.hasOwnProperty('notice1Date')) {
            console.log(this.getBookingOutcomeAnswer(config.myCeremony['give-notice'].outcomes.notice1Date));
            const tmp = this.getBookingOutcomeAnswer(config.myCeremony['give-notice'].outcomes.notice1Date);
            if (tmp && tmp.length > 0) {
              this.notice1Date = moment(this.getBookingOutcomeAnswer(config.myCeremony['give-notice'].outcomes.notice1Date)).utc().tz('Europe/London').format('DD/MM/YYYY');
            }
            else {
              this.notice1Date = '';
            }
            
          }
          if (config.myCeremony['give-notice'].outcomes.hasOwnProperty('given1Date')) {
            const tmp = this.getBookingOutcomeAnswer(config.myCeremony['give-notice'].outcomes.given1Date);
            if (tmp && tmp.length > 0) {
              this.notice1Date = moment(this.getBookingOutcomeAnswer(config.myCeremony['give-notice'].outcomes.given1Date)).utc().tz('Europe/London').format('DD/MM/YYYY');
            }
          }

          if (config.myCeremony['give-notice'].outcomes.hasOwnProperty('notice2Date')) {
            const tmp = this.getBookingOutcomeAnswer(config.myCeremony['give-notice'].outcomes.notice2Date);
            console.log(config.myCeremony['give-notice'].outcomes.notice2Date, tmp);
            if (tmp && tmp.length > 0) {
              this.notice2Date = moment(this.getBookingOutcomeAnswer(config.myCeremony['give-notice'].outcomes.notice2Date)).utc().tz('Europe/London').format('DD/MM/YYYY');
            }
            else {
              this.notice2Date = '';
            }
          }
          if (config.myCeremony['give-notice'].outcomes.hasOwnProperty('given2Date')) {
            const tmp = this.getBookingOutcomeAnswer(config.myCeremony['give-notice'].outcomes.given2Date);
            if (tmp && tmp.length > 0) {
              this.notice2Date = moment(this.getBookingOutcomeAnswer(config.myCeremony['give-notice'].outcomes.given2Date)).utc().tz('Europe/London').format('DD/MM/YYYY');
            }
          }
        }
      }
    }

    console.log('notice1Date', this.notice1Date, 'notice2Date', `|${this.notice2Date}|`);

  }

  getBookingOutcomeAnswer(questionId: number) {
    const answer = this.booking._embedded.answers.find((f:any) => f.question_id == questionId);
    console.log(questionId, answer);
    if (answer) {
      return answer.value;
    }
    return '';
  }

  async setupGiveNotice1Form() {
    if (!this.giveNotice1FormEditing) {
      this.giveNotice1FormEditing = true;
      this.giveNotice1Form = new FormGroup({});
      const giveNotice1Control = new FormControl(this.notice1Date, [Validators.required]);
      this.giveNotice1Form.addControl('notice', giveNotice1Control);
    }
    else {
      if (this.giveNotice1Form.valid) {
        console.log(this.form1);
        this.booking.questions[this.config.myCeremony['give-notice'].outcomes.notice1Date] = {answer: this.form1['notice'].value};
        const updatedBooking = await this.updateBooking({questions: this.booking.questions});
        this.booking = updatedBooking;
        console.log(updatedBooking);
        const tmpVal = this.getBookingOutcomeAnswer(this.config.myCeremony['give-notice'].outcomes.notice1Date);
        this.notice1Date = moment(tmpVal).utc().tz('Europe/London').format('DD/MM/YYYY');
        this.giveNotice1FormEditing = false;
      }
    }
  }

  cancelGiveNotice1Form() {
    this.giveNotice1FormEditing = false;
  }

  async setupGiveNotice2Form() {
    if (!this.giveNotice2FormEditing) {
      this.giveNotice2FormEditing = true;
      this.giveNotice2Form = new FormGroup({});
      const giveNotice2Control = new FormControl(this.notice2Date, [Validators.required]);
      this.giveNotice2Form.addControl('notice', giveNotice2Control);
      this.giveNotice2Form.valueChanges.subscribe(values => {
        console.log(values,this.giveNotice2Form.pristine, this.giveNotice2Form);
      });
    }
    else {
      if (this.giveNotice2Form.valid) {
        console.log(this.form2);
        this.booking.questions[this.config.myCeremony['give-notice'].outcomes.notice2Date] = {answer: this.form2['notice'].value};
        const updatedBooking = await this.updateBooking({questions: this.booking.questions});
        this.booking = updatedBooking;
        console.log(updatedBooking);
        const tmpVal = this.getBookingOutcomeAnswer(this.config.myCeremony['give-notice'].outcomes.notice2Date);
        this.notice2Date = moment(tmpVal).utc().tz('Europe/London').format('DD/MM/YYYY');
        this.giveNotice2FormEditing = false;
      }
    }
  }

  cancelGiveNotice2Form() {
    this.giveNotice2FormEditing = false;
  }

  async updateBooking(data: any) {
    try {
      const updatedBooking:any = await this.apiService.updateBooking(data, this.booking.company_id, this.booking.id, false);
      this.dataStore.booking = updatedBooking;
      localStorage.setItem('ceremony', JSON.stringify(updatedBooking));
      return updatedBooking;
    }
    catch (err) {
      console.error(err);
    }
  }

}
